import { render, staticRenderFns } from "./CSelect.vue?vue&type=template&id=a51d0878&scoped=true&lang=pug&"
import script from "./CSelect.vue?vue&type=script&lang=ts&"
export * from "./CSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CSelect.vue?vue&type=style&index=0&id=a51d0878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51d0878",
  null
  
)

export default component.exports